import React from 'react';
import ColumnWidthToggleButton from './Buttons/ColumnWidthToggleButton';
import PinColumnButton from './Buttons/PinColumnButton';

/**
 * A simplified column header component with pin and width toggle buttons
 * Pin button is only visible on hover when not pinned
 */
const SimpleColumnHeader = ({
  title,
  columnId,
  isPinned,
  onTogglePin,
  isActive,
  onToggleWidth,
  children
}) => {
  const handlePinClick = (id) => {
    onTogglePin(id);
  };
  
  return (
    <div className="column-header-container flex flex-col items-center group">
      
      
      {/* Header content */}
      <div 
        className={`text-center text-sm mb-4 font-gazer-header ${
          isActive ? 'mt-2' : ''
        }`}
      >
        {title}
      </div>
      
      {/* Any additional content like dropdowns */}
      {children}
    </div>
  );
};

export default SimpleColumnHeader;